import { type ReactElement, type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

interface Props {
  children: ReactNode;
}

/** Wraps protected routes: redirects to /login when not authenticated. The
 * LoginPage itself is rendered OUTSIDE this gate so it doesn't loop. */
export function AuthGate({ children }: Readonly<Props>): ReactElement {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-slate-500">
        Loading&hellip;
      </div>
    );
  }
  if (user === null) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
